import { Unit } from './interfaces';

const fluxElectronPerSecond: Unit = { value: 'electron/s', viewValue: 'Electron / s' };
const fluxPartsPerMillion: Unit = { value: 'ppm', viewValue: 'ppm' };
const xmmFluxCts: Unit = { value: 'ct/s', viewValue: 'ct / s' };
const Jy: Unit = { value: 'Jy', viewValue: 'Jy' };
const mJy: Unit = { value: 'mJy', viewValue: 'mJy' };

export { fluxElectronPerSecond, fluxPartsPerMillion, xmmFluxCts, Jy, mJy };
